export default __webpack_public_path__ + "static/media/list_red_icon.5690c07b.svg";